import { useLocation } from "react-router";
import { FooterProps } from "@layouts/Footer";
import { HeaderProps } from "@layouts/Header";

class ECoaLocationRegex {
  static HOME_CODE_VERIFICATION = /^\/$/;
  static HOME_IDENTITY_VERIFICATION = /^\/auth\/birth+$/;
  static HOME_SMS_VERIFICATION = /^\/auth\/sms+$/;

  static ECOA_RECRUIT = /\/recruit$/;

  static ECOA_VISITS = /^\/pat\/visits$/;
  static ECOA_VISIT_ENTRANCE = /^\/pat\/visits\/[A-Za-z0-9]+\/[A-Za-z0-9_]+\/[A-Za-z0-9]+\/[A-Za-z0-9_]+\/[A-Za-z0-9]+$/;
  static ECOA_VISIT_QUESTIONNAIRE = /^\/pat\/visits\/[A-Za-z0-9]+\/[A-Za-z0-9_]+\/[A-Za-z0-9]+\/[A-Za-z0-9_]+\/[A-Za-z0-9]+\/[A-Za-z0-9]+$/;
  static ECOA_VISIT_QUESTIONNAIRE_DONE = /^\/pat\/visits\/[A-Za-z0-9]+\/[A-Za-z0-9_]+\/[A-Za-z0-9]+\/[A-Za-z0-9_]+\/[A-Za-z0-9]+\/done$/;
  static ECOA_CRFS = /^\/pat\/crfs\/[A-Za-z0-9]+\/[A-Za-z0-9_]+\/[A-Za-z0-9]+$/;
}

const FAQ_URL = "https://jnpmedi.atlassian.net/wiki/x/5YDsDg";

const get = (location: {
  pathname: string;
}): {
  header: HeaderProps;
  footer: FooterProps;
} => {
  if (location.pathname.match(ECoaLocationRegex.HOME_CODE_VERIFICATION) || location.pathname.match(ECoaLocationRegex.ECOA_RECRUIT)) {
    return {
      header: {
        icon: "WavingHand",
        right: {
          icon: "Unknown",
          onClick: () => window.open(FAQ_URL),
        },
      },
      footer: { dummy: true },
    };
  } else if (location.pathname.match(ECoaLocationRegex.HOME_IDENTITY_VERIFICATION)) {
    return {
      header: {
        icon: "Calendar",
        left: { icon: "ChromeBack", path: "/" },
        right: {
          icon: "Unknown",
          onClick: () => window.open(FAQ_URL),
        },
      },
      footer: { dummy: true },
    };
  } else if (location.pathname.match(ECoaLocationRegex.HOME_SMS_VERIFICATION)) {
    return {
      header: {
        icon: "Message",
        left: { icon: "ChromeBack", path: "/" },
        right: {
          icon: "Unknown",
          onClick: () => window.open(FAQ_URL),
        },
      },
      footer: { dummy: true },
    };
  } else if (location.pathname.match(ECoaLocationRegex.ECOA_VISITS)) {
    return {
      header: {
        appName: true,
        right: {
          icon: "Unknown",
          onClick: () => window.open(FAQ_URL),
        },
      },
      footer: { dummy: true },
    };
  } else if (location.pathname.match(ECoaLocationRegex.ECOA_VISIT_ENTRANCE)) {
    return {
      header: {
        icon: "UserOptional",
        title: {
          ko: "안내사항",
          en: "Notice",
          fr: "Avis",
          nl: "Mededeling",
        },
        left: { reserved: "BACK" },
        right: {
          icon: "Unknown",
          onClick: () => window.open(FAQ_URL),
        },
      },
      footer: { dummy: true },
    };
  } else if (location.pathname.match(ECoaLocationRegex.ECOA_VISIT_QUESTIONNAIRE_DONE)) {
    return {
      header: {
        icon: "DocumentApproval",
        left: { reserved: "HOME" },
        right: {
          icon: "Unknown",
          onClick: () => window.open(FAQ_URL),
        },
      },
      footer: { dummy: true },
    };
  } else if (location.pathname.match(ECoaLocationRegex.ECOA_VISIT_QUESTIONNAIRE)) {
    return {
      header: {
        dummy: true,
        left: { reserved: "HOME" },
        right: {
          icon: "Unknown",
          onClick: () => window.open(FAQ_URL),
        },
      },
      footer: { dummy: true },
    };
  } else if (location.pathname.match(ECoaLocationRegex.ECOA_CRFS)) {
    return {
      header: {
        appName: true,
        left: { icon: "ChromeBack", path: "/" },
        right: {
          icon: "Unknown",
          onClick: () => window.open(FAQ_URL),
        },
      },
      footer: { dummy: true },
    };
  }

  return {
    header: {
      appName: true,
    },
    footer: { dummy: false },
  };
};

export function useEcoaBreadcrumb() {
  const location = useLocation();
  const { header, footer } = get(location);

  return {
    header,
    footer,
  };
}
